import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { DocumentoVendaSearchFilter } from 'src/app/model/documentoVenda/documentoVendaSearchFilter';
import { DocumentoVendaService } from '../documentoVenda.service';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-browse-filter',
    templateUrl: './documentoVenda-browse-filter.component.html',
    standalone: false
})
export class DocumentoVendaBrowseFilterComponent implements OnInit, OnDestroy {

  @Input() filter: DocumentoVendaSearchFilter;

  public dataInicio: NgbDate;
  public dataFim: NgbDate;

  private subQueryParam: any;

  constructor(private router: Router, private route: ActivatedRoute, private service: DocumentoVendaService) {
  }

  ngOnInit(): void {
    this.subQueryParam = this.route.queryParams
      .subscribe(queryParams => {
        if (queryParams) {
          const filter = this.filter;
          Object.getOwnPropertyNames(queryParams)
            .forEach((val: string, idx: number, array: string[]) => {
              const property = array[idx];
              const value = queryParams[property];
              filter[property] = value;

              if (property === 'dataInicio') {
                const myDate = new Date(value);
                filter[property] = myDate;
                this.dataInicio = new NgbDate(myDate.getUTCFullYear(), myDate.getUTCMonth() + 1, myDate.getUTCDate());
              }
              if (property === 'dataFim') {
                const myDate = new Date(value);
                filter[property] = myDate;
                this.dataFim = new NgbDate(myDate.getUTCFullYear(), myDate.getUTCMonth() + 1, myDate.getUTCDate());
              }
            });
        }
      });
  }

  ngOnDestroy(): void {
    if (this.subQueryParam) { this.subQueryParam.unsubscribe(); }
  }

  selectDataInicio(dataInicio: NgbDate) {
    if (dataInicio) {
      this.filter.dataInicio = new Date(Date.UTC(dataInicio.year, dataInicio.month - 1, dataInicio.day, 0, 0, 0));
    } else {
      this.filter.dataInicio = undefined;
    }
  }

  selectDataFim(dataFim: NgbDate) {
    if (dataFim) {
      this.filter.dataFim = new Date(Date.UTC(dataFim.year, dataFim.month - 1, dataFim.day, 0, 0, 0));
    } else {
      this.filter.dataFim = undefined;
    }
  }
}
